import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const PageTitle = ({ htmlTitle }) => (
  <React.Fragment>
    <span />
    <Helmet>
      <meta charSet="utf-8" />
      <title>{htmlTitle}</title>
    </Helmet>
  </React.Fragment>
);

PageTitle.propTypes = {
  htmlTitle: PropTypes.string.isRequired,
};

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/pageTitle/PageTitle.jsx